import { BOXGROUP_ID, ID_GROUPS } from "../../../../Utils/const"
import { InterpolationSource } from "../../Interpolation/data"

const infoBR = {
    "1FR7SFS7": {
        path: "SongRay",
        ratio: 100,
        defaultVal: 0,
        defaultLeft: 253,
        defaultRight: 915,
        defaultY: 604,
        widthLine: 670.5
    },
    "39YB6FYB": {
        path: "DaBang",
        ratio: 14.8,
        defaultVal: 25.04,
        defaultY: 572,
        defaultLeft: 110,
        defaultRight: 312,
        widthLine: 202,
        radian: 3.4
    },
    "QYKVQ88A": {
        path: "XuyenMoc",
        ratio: 37,
        defaultVal: 11.89,
        defaultY: 575,
        defaultLeft: 121,
        defaultRight: 326,
        widthLine: 211,
        radian: 2.95
    },
    "9MT7YREL": {
        path: "SuoiCac",
        ratio: 19,
        defaultVal: 67,
        defaultY: 567,
        defaultLeft: 96,
        defaultRight: 305,
        widthLine: 210,
        radian: 3.4
    },
    "LNYOCWEP": {
        path: "KimLong",
        ratio: 18.1,
        defaultVal: 98.4,
        defaultY: 570,
        defaultLeft: 112,
        defaultRight: 312,
        widthLine: 200,
        radian: 3.3
    },
    "JRUTJ9KX": {
        path: "ChauPha",
        ratio: 37.5,
        defaultVal: 24,
        defaultY: 553,
        defaultLeft: 114,
        defaultRight: 313,
        widthLine: 200,
        radian: 3.4
    }
}

function lerp(x1, x2, v1, v2, x) {
    if (x2 === x1) return v1
    return v1 + (v2 - v1) * (x - x1) / (x2 - x1)
}

function interpolateVolumeBR(Z) {
    const info = InterpolationSource.find(s => s.group_id === BOXGROUP_ID)
    const V = info.V
    const y0 = Math.floor(Z)
    const x = +(Z - y0).toFixed(10) // tránh lỗi float

    const yIndex = V.y.indexOf(y0)
    if (yIndex === -1) return null

    const xs = V.x
    const row = V.value[yIndex]

    for (let i = 0; i < xs.length - 1; i++) {
        if (x >= xs[i] && x <= xs[i + 1]) {
            const v = lerp(xs[i], xs[i + 1], row[i], row[i + 1], x)
            return Math.round(v * 100) / 100
        }
    }

    return null
}

// aVal = dr value 
// hVal = wau value
function interpolateDrainBR(aVal, hVal) {
    const eVal = 0.63
    const qVal = 0.94
    const bVal = 4
    const gVal = 9.8
    const sqrtVal = Math.abs(2 * gVal * (hVal - eVal * aVal)) 
    const result = eVal * qVal * aVal * bVal * Math.sqrt(sqrtVal)
    return Math.round(result * 100) / 100
}

function getCVal() {
    if (BOXGROUP_ID === ID_GROUPS.DB) return 25
    else if(BOXGROUP_ID === ID_GROUPS.KL) return 102
    else if (BOXGROUP_ID === ID_GROUPS.XM) return 12
    else if (BOXGROUP_ID === ID_GROUPS.SC) return 69.75
    else if (BOXGROUP_ID === ID_GROUPS.CP) return 23.8
    return 1
}

function getWaVal() {
    if (BOXGROUP_ID === ID_GROUPS.DB) return 0.502654825
    else if(BOXGROUP_ID === ID_GROUPS.KL) return 0.125663706
    else if (BOXGROUP_ID === ID_GROUPS.XM) return 0.96
    else if (BOXGROUP_ID === ID_GROUPS.SC) return 0.96
    else if (BOXGROUP_ID === ID_GROUPS.CP) return 1.2
    return 1
}

function getHVal() {
    if (BOXGROUP_ID === ID_GROUPS.DB) return 0.8
    else if(BOXGROUP_ID === ID_GROUPS.KL) return 0.4
    else if (BOXGROUP_ID === ID_GROUPS.XM) return 1.2
    else if (BOXGROUP_ID === ID_GROUPS.SC) return 1.2
    else if (BOXGROUP_ID === ID_GROUPS.CP) return 1.2
    return 1
}

const table = [
  { hH: 0.01, E: 0.6 },
  { hH: 0.10, E: 0.617 },
  { hH: 0.20, E: 0.620 },
  { hH: 0.25, E: 0.622 },
  { hH: 0.30, E: 0.625 },
  { hH: 0.35, E: 0.628 },
  { hH: 0.40, E: 0.633 },
  { hH: 0.45, E: 0.638 },
  { hH: 0.50, E: 0.645 },
  { hH: 0.55, E: 0.650 },
  { hH: 0.60, E: 0.660 },
];

function interpolateE(hH) {
  // Nhỏ hơn giá trị nhỏ nhất
  if (hH <= table[0].hH) {
    return table[0].E;
  }

  // Lớn hơn giá trị lớn nhất
  if (hH >= table[table.length - 1].hH) {
    return table[table.length - 1].E;
  }

  // Nội suy
  for (let i = 0; i < table.length - 1; i++) {
    const p1 = table[i];
    const p2 = table[i + 1];

    if (hH >= p1.hH && hH <= p2.hH) {
      return (
        p1.E +
        ((hH - p1.hH) * (p2.E - p1.E)) / (p2.hH - p1.hH)
      );
    }
  }
}

function newInterpolateDrainBR(dr, wau) {
    const cVal = getCVal()
    const H = wau - cVal
    const hVal = getHVal()
    const eVal = interpolateE(hVal/H)
    const zVal = H - dr * eVal
    const qval = 0.94
    const gVal = 9.81
    const waVal = getWaVal()
    const sqrtVal = Math.abs(2 * gVal * zVal)
    const result = qval * eVal * waVal * Math.sqrt(sqrtVal)
    return result.toFixed(3)
}

function interpolateSR(dr, wau) {
    const cd = 0.61
    const b = 4
    const a = dr / 100
    const g = 9.81
    const H = wau
    const Q = cd * b * a * Math.sqrt(2 * g * H)
    return Q.toFixed(3)
}

export { infoBR, interpolateVolumeBR, interpolateDrainBR, newInterpolateDrainBR ,interpolateSR }